/**
 * Protocol-level types for the stream communication
 */
/**
 * All possible message types in the stream protocol
 */
export const StreamMessageTypes = {
    /** Stream data message */
    STREAM_DATA: 'STREAM_DATA',
    /** Function call from AI */
    FUNCTION_CALL: 'FUNCTION_CALL',
    /** Function result */
    FUNCTION_RESULT: 'FUNCTION_RESULT',
    /** Error message */
    ERROR: 'ERROR',
    /** Connection established message */
    CONNECTION_ESTABLISHED: 'CONNECTION_ESTABLISHED',
    /** User message */
    USER_MESSAGE: 'USER_MESSAGE',
    /** Message started event */
    MESSAGE_STARTED: 'MESSAGE_STARTED',
    /** Message completed event */
    MESSAGE_COMPLETED: 'MESSAGE_COMPLETED',
    /** State synchronization message */
    STATE_SYNC: 'STATE_SYNC',
    /** Session resumption request */
    SESSION_RESUME: 'SESSION_RESUME',
    /** Session resumption response */
    SESSION_RESUME_RESPONSE: 'SESSION_RESUME_RESPONSE',
};
/**
 * Enum for stream error codes.
 *
 * @readonly
 * @enum {string}
 */
export const StreamErrorCode = {
    /** Rate limit exceeded */
    RATE_LIMIT: 'rate_limit',
    /** API error occurred */
    API_ERROR: 'api_error',
    /** OpenAI error occurred */
    OPENAI_ERROR: 'openai_error',
    /** Function execution error */
    FUNCTION_ERROR: 'function_error',
    /** Validation error */
    VALIDATION_ERROR: 'validation_error',
    /** Unknown error occurred */
    UNKNOWN_ERROR: 'unknown_error',
    /** Connection error occurred */
    CONNECTION_ERROR: 'connection_error',
    /** Connection was closed */
    CONNECTION_CLOSED: 'connection_closed',
    /** Session resumption failed */
    SESSION_RESUME_FAILED: 'session_resume_failed',
    /** State synchronization error */
    STATE_SYNC_ERROR: 'state_sync_error',
    /** State conflict detected */
    STATE_CONFLICT: 'state_conflict',
    /** Server error occurred */
    SERVER_ERROR: 'server_error',
    /** Connection timeout */
    CONNECTION_TIMEOUT: 'connection_timeout',
};
import { StreamMessageSchema } from './message-schema';
/**
 * Parses a stream message from a string
 *
 * @param {string} input - The input string to parse
 * @returns {StreamMessage} The parsed stream message
 */
export const parseStreamMessage = (input) => {
    try {
        const json = JSON.parse(input);
        const parsedMessage = StreamMessageSchema.safeParse(json);
        if (!parsedMessage.success) {
            throw new Error('Invalid stream message: ' + parsedMessage.error.message);
        }
        return parsedMessage.data;
    }
    catch (e) {
        throw new Error('Invalid stream message: ' + e.message);
    }
};
//# sourceMappingURL=types.js.map